import React from 'react';
import Announcement from '../Announcement';
import {SUMMER_1} from '../../../colors';


export default function GiftAnnouncement() {
    return (
        <Announcement
            analyticsEvent='winter_gift'
            href='/user/gift/'
            buttonText='Send a Gift Membership'
            style={{backgroundColor: SUMMER_1}}
        >
            Give the Gift of Adventure this Season
        </Announcement>
    );
}
